export enum RuleFilterEntityType {
  Account = 'Account',
  Branch = 'Branch',
  Depot = 'Depot',
  ItemType = 'ItemType',
  LineType = 'custom',
  AgentStatus = 'custom',
  CustomizedServiceField = 'custom',
  ProgramType = 'ProgramType',
  Area = 'Area',
  SubtaskTemplate = 'SubtaskTemplate',
  LabelType = 'LabelType'
}
